/* eslint-disable import/prefer-default-export */
import { storageService } from 'services/axiosHandler';

const path = 'documents';

export const uploadRequest = async (files, category, secureType = 'protected') => {
    const fd = new FormData();

    fd.append('category', category);
    fd.append('secure_type', secureType);
    files.forEach((x,i) => {
        fd.append(`file${i+1}`,x)
    })

    const res = await storageService.post(`/${path}`, fd, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })

    if (res.status !== 201) {
        throw res.data.message || res.statusText || res
    }

    return res.data;
};